import { createUserTracking } from '@thehotelsnetwork/vue-user-tracking';

import { settings } from './config';

export const userTracking = createUserTracking(settings);
